import { Link as GatsbyLink } from 'gatsby';
import { PostsPage } from "../../../../src/components/PostsPage";
import * as React from 'react';
export default {
  GatsbyLink,
  PostsPage,
  React
};